import { connect } from 'react-redux';
import SiteListingMaintenace from './siteListingMaintenance';
import { bindActionCreators } from 'redux';
import { fetchGoLiveSites, getGOLiveFilterDropDown } from "services/redux/maintenance/goLiveSite/action";
import {
  getSiteListingMaintenance
} from 'services/redux/installation/siteListing/action';

const mapStateToProps = (state) => ({
  siteListData: state.siteListingReducer.siteListData,
  liveFilterDropDown: state.liveSiteDataReducer.liveFilterDropDown
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getSiteListingMaintenance,
      getGOLiveFilterDropDown
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(SiteListingMaintenace);
